import * as types from "../actions/action-types";
import { filter, isEqual, uniqWith } from "lodash";
const initialState = {
	notifications: [],
	fetchingNotifications: false,
	deleteInProgress: false,
	deleteComplete: false,
	deleteGridItem: false,
	deleteGridItemInProgress: false,
	fetchingGraphDetail: false,
	GraphDetail: [],
	Description: "",
	Title: "",
	navTitle: "",
	fetchingTotalTillDateByKey: false,
	totalTillDate: [],
	drillUp: false
};

const globalNotificationReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case `${types.GET_ALL_NOTIFICATIONS}_PENDING`:
			return Object.assign({}, state, {
				fetchingNotifications: true
			});

		case `${types.GET_ALL_NOTIFICATIONS}_FULFILLED`:
			return Object.assign({}, state, {
				fetchingNotifications: false,
				notifications: action.payload
			});

		case `${types.GET_ALL_NOTIFICATIONS}_REJECTED`:
			return {
				isRejected: true,
				error: "get notification settings failed"
			};

		case `${types.DELETE_NOTIFICATION}_PENDING`:
			return Object.assign({}, state, {
				deleteInProgress: true,
				deleteComplete: false
			});

		case `${types.DELETE_NOTIFICATION}_FULFILLED`:
			return Object.assign({}, state, {
				deleteInProgress: false,
				deleteComplete: true
			});

		case `${types.DELETE_NOTIFICATION}_REJECTED`:
			return {
				isRejected: true,
				error: "get notification settings failed"
			};
		case `${types.NOTIFICATION_SUBITEM_DELETE}_PENDING`:
			return Object.assign({}, state, {
				deleteGridItemInProgress: true,
				deleteGridItem: false
			});

		case `${types.NOTIFICATION_SUBITEM_DELETE}_FULFILLED`:
			return Object.assign({}, state, {
				deleteGridItemInProgress: false,
				deleteGridItem: true
			});

		case `${types.NOTIFICATION_SUBITEM_DELETE}_REJECTED`:
			return {
				isRejected: true,
				error: "get notification settings failed"
			};
		// Below code is added for drilldown
		/*************************Fetch notification detail action states START ***************************/
		case `${types.FETCH_NOTIFICATION_DETAILS_GLOBAL}_PENDING`:
			return Object.assign({}, state, {
				GraphDetail: [],
				fetchingGraphDetail: true,
				navTitle: "",
				prevState: {}
			});

		case `${types.FETCH_NOTIFICATION_DETAILS_GLOBAL}_FULFILLED`:
			return Object.assign({}, state, {
				GraphDetail: action.payload.data || action.payload.data.Data,
				//GraphDetail: graphData,
				Description: action.payload.data.Description,
				Title: action.payload.data.Title,
				fetchingGraphDetail: false,
				serverError: false
			});

		case `${types.FETCH_NOTIFICATION_DETAILS_GLOBAL}_REJECTED`:
			return {
				isRejected: true,
				error: "Fetch GraphDetail action Failed"
			};
		/*************************Fetch notification detail action states END ***************************/
		/*************************Fetch TOTAL_TILL_DATE action states START ***************************/
		case `${types.NOTIFICATION_FETCH_DETAIL_TOTAL_TILL_DATE}_PENDING`:
			return Object.assign({}, state, {
				fetchingTotalTillDateByKey: true,
				totalTillDate: []
			});

		case `${types.NOTIFICATION_FETCH_DETAIL_TOTAL_TILL_DATE}_FULFILLED`:
			return Object.assign({}, state, {
				totalTillDate: action.payload.data.Data,
				fetchingTotalTillDateByKey: false,
				serverError: false
			});

		case `${types.NOTIFICATION_FETCH_DETAIL_TOTAL_TILL_DATE}_REJECTED`:
			return {
				isRejected: true,
				error: "Fetch TOTAL Till Date action Failed"
			};
		/*************************Fetch TOTAL_TILL_DATE detail action states END ***************************/


		case `${types.NOTIFICATION_DRILL_DOWN}`:
			return {
				...state,
				GraphDetail: action.drillDownData,
				navTitle: action.navTitle,
				prevState: { ...state },
				drillUp: false
			};

		case `${types.NOTIFICATION_DRILL_UP}`:
			return {
				...state,
				...state.prevState,
				drillUp: true
			};
		/*************************Fetch Summary Details action states START ***************************/
		case `${types.FETCH_NOTIFICATION_SUMMARY_DETAILS}_PENDING`:
			return {
				...state,
				fetchingSummaryDetail: true
			};
		// Check if drillup is clicked.If yes do not set the graphdetail
		case `${types.FETCH_NOTIFICATION_SUMMARY_DETAILS}_FULFILLED`:
			return {
				...state,
				fetchingSummaryDetail: false,
				GraphDetail: !state.drillUp
					? action.payload.data
					: state.GraphDetail,
				navTitle: !state.drillUp ? action.meta.navTitle : state.navTitle
				// no need to set prevState as we are fetching remote data
				// prevState: {...state}
			};

		case `${types.FETCH_NOTIFICATION_SUMMARY_DETAILS}_REJECTED`:
			return {
				...state,
				fetchingSummaryDetail: false,
				error: action.err
			};

		default:
			return state;
	}
};

export default globalNotificationReducer;



// WEBPACK FOOTER //
// ./src/features/common/GlobalNotification/reducer/index.js